import type { Vector2 } from '@sorrem/shared';

/** Small numeric helpers the skill tree's layout, geometry, and animation share. */

export function clamp(value: number, min: number, max: number): number {
    return Math.min(max, Math.max(min, value));
}

export function clamp01(value: number): number {
    return Math.min(1, Math.max(0, value));
}

export function lerp(from: number, to: number, amount: number): number {
    return from + (to - from) * amount;
}

/** Wraps a value into [0, size). */
export function wrap(value: number, size: number): number {
    return ((value % size) + size) % size;
}

export function toRadians(degrees: number): number {
    return (degrees * Math.PI) / 180;
}

/** The point `radius` from `center` at `degrees` clockwise from +x (y grows downward). */
export function polar(center: Vector2, radius: number, degrees: number): Vector2 {
    const radians = toRadians(degrees);
    return { x: center.x + radius * Math.cos(radians), y: center.y + radius * Math.sin(radians) };
}
